//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('discGrpCust', {
//        templateUrl: 'views/components/views/discGrpCust/discGrpCust.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'discGrpCustService', function ($stateParams, stateService, modalService, translateService, discGrpCustService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let discGrpCustKeyno = $stateParams.discgrpcust_keyno;

//            let translations = {
//            	error: '',
//            	ok: ''
//            };

//            vm.model = {
//                discGroupNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('discgrpcustlangs', { discgrpcust_keyno: vm.model.edit.discgrpcust_keyno }) }
//                ],
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await discGrpCustService.getEdit({ discgrpcust_keyno: discGrpCustKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS
            
//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                discGrpCustService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//            	loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
